export const COLORS = {
  alert: '#FFB81C',
  black: '#320F00',
  blueFonts: '#004C97',
  darkGray: '#898C95',
  error: '#F82D2D',
  gray: '#C7C9C7',
  headerColor: '#D1E2EA',
  info: 'rgba(0,0,0,0.5)',
  lightGray: '#E5E4E4',
  pink: '#FDD4D4',
  primary: '#FFE4A5',
  secondary: '#F8EBCC',
  success: '#59A83B',
  tableColor: '#B6CFE6',
  transparent: 'transparent',
  white: '#FEFEFE'
}
